/**
 * Hook + componente Guard para páginas dependentes de Pausas estar ativado.
 *
 * Uso nas páginas Motivos e Histórico:
 *   <PausesEnabledGuard>...conteúdo...</PausesEnabledGuard>
 */
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "./api";
import DashboardLayout from "../components/layout/DashboardLayout";
import { Button } from "../components/ui/button";
import { Skeleton } from "../components/ui/skeleton";
import { Pause, Settings } from "lucide-react";
import { accentBg, accentBgLight, accentText } from "./accent";

export function usePausesEnabled() {
  const [state, setState] = useState({ loading: true, enabled: false });
  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const { data } = await api.get("/settings/mobile/pauses");
        if (mounted) setState({ loading: false, enabled: data?.enabled !== false });
      } catch {
        if (mounted) setState({ loading: false, enabled: false });
      }
    })();
    return () => {
      mounted = false;
    };
  }, []);
  return state;
}

export function PausesEnabledGuard({ children }) {
  const { loading, enabled } = usePausesEnabled();
  if (loading) {
    return (
      <DashboardLayout>
        <div className="space-y-2">
          {Array.from({ length: 5 }).map((_, i) => (
            <Skeleton key={i} className="h-14 w-full" />
          ))}
        </div>
      </DashboardLayout>
    );
  }
  if (!enabled) {
    return (
      <DashboardLayout>
        <div className="bg-white dark:bg-slate-900 rounded-xl border border-dashed border-gray-300 dark:border-slate-700 py-16 px-6 text-center max-w-2xl mx-auto mt-8">
          <div
            className="h-16 w-16 rounded-2xl mx-auto flex items-center justify-center"
            style={accentBgLight()}
          >
            <Pause className="h-7 w-7" style={accentText()} />
          </div>
          <h3 className="mt-5 text-lg font-semibold text-gray-900 dark:text-white">
            Pausas estão desativadas
          </h3>
          <p className="mt-2 text-sm text-gray-500 max-w-md mx-auto">
            Ative o recurso na página de Configurações para poder cadastrar motivos, ver o histórico e liberar o botão Pausar no app do prestador.
          </p>
          <Link to="/settings/pauses/general">
            <Button className="mt-6 text-white gap-1.5" style={accentBg()} data-testid="go-to-general-btn">
              <Settings size={15} />
              Ir para Configurações
            </Button>
          </Link>
        </div>
      </DashboardLayout>
    );
  }
  return children;
}
